import axios from './axios'
import { Toast } from 'vant';

let baseURL = '',
    baseURL2 = '',
    baseURL3 = '',
    baseURL4 = '',
    baseURL6 = '',
    baseURL7 = '',
    baseURL8 = '',
    baseURL9 = '';
const domain = 'bitdisk.io';
// const domain = 'safeswim.io';
const MethodType = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    DELETE: 'DELETE',
}

if (process.env.NODE_ENV === 'production') {
    baseURL = `https://walletapi.${domain}`;
    baseURL2 = `https://wxj.cume.cc`;
    // baseURL2 = `https://walletapi.${domain}`;
    // baseURL3 = `https://rsp.${domain}`;
    baseURL3 = `https://logintest.cume.cc`;
    baseURL4 = `https://walletapi.${domain}`;
    baseURL6 = `https://walletapi.${domain}/revest`;
    baseURL7 = `https://walletapi.${domain}`;
    baseURL8 = `https://walletapi.${domain}/SEJ`;
    baseURL9 = `https://walletapi.${domain}/c-advance`;
} else {
    baseURL = `https://walletapidev.${domain}:4443`;
    // baseURL2 = `https://walletapidev.${domain}:4443`;
    baseURL2 = `https://wyxj.cume.cc`;
    // baseURL3 = `https://rspdev.${domain}:4443`;
    baseURL3 = `https://logintest.cume.cc`;
    baseURL4 = `https://walletapidev.${domain}:4443`;
    baseURL6 = `https://walletapidev.${domain}:4443/revest`;
    baseURL7 = `https://walletapidev.${domain}:4443`; // 春节不管
    baseURL8 = `https://walletapidev.${domain}:4443/SEJ`;
    baseURL9 = `https://walletapidev.${domain}:4443/c-advance`;
}

function promiseRequest(api, method = MethodType.GET, params = {}, domainItem = 'M2', loadingLoader, config = {}) {
    if (params['loadingLoader']) {
        loadingLoader = params['loadingLoader']
        delete params['loadingLoader']
    }
    // console.log('--------28------------------------------------------', params);
    const data = (method === 'GET') ? 'params' : 'data';
    let headers = {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json'
    };
    if (config.headers) {
        headers = {
            ...headers,
            ...config.headers
        }
    }
    switch (domainItem) {
        case 'M1':
            axios.defaults.baseURL = baseURL;
            break;
        case 'M2':
            axios.defaults.baseURL = baseURL2;
            break;
        case 'M3':
            axios.defaults.baseURL = baseURL3;
            break;
        case 'M4':
            axios.defaults.baseURL = baseURL4;
            break;
        case 'M6':
            axios.defaults.baseURL = baseURL6;
            break;
        case 'M7':
            axios.defaults.baseURL = baseURL7;
            break;
        case 'M8':
            axios.defaults.baseURL = baseURL8;
            break;
        case 'M9':
            axios.defaults.baseURL = baseURL9;
            break;
        default:
            axios.defaults.baseURL = baseURL2;
    }

    axios.defaults.withCredentials = true;
    let _p = new Promise((resolve, reject) => {
        axios({
            url: api,
            method,
            [data]: params,
            headers,
            loadingLoader,
            // withCredentials:'true',  
            timeout: 60000,
        }).then(function(response) {
            let serverTime = response.headers['server-curr-mills'];
            if (serverTime && response.data && response.data.data && Object.prototype.toString.call(response.data.data) === '[object Object]') {
                response.data.data['serverTime'] = serverTime
                window.localStorage.setItem('serverTime', serverTime);
            }
            // 8004 享购维护
            //40035 "未开通外网增值服务";
            //40036 "暂未开通外网访问服务";
            if (response.data.code !== 1 && response.data.code !== 8004 && response.data.code !== 40035 && response.data.code !== 40036) {
                Toast.clear();
                Toast(response.data.info || '服务器错误')
            }

            resolve(response)
        }).catch(error => {
            console.log(error, '<----------------error');
            window.shoTooHot && window.shoTooHot(true); // 控制toast 
            // switch (error.response.status) { 
            //   case 599:
            //   case 507:
            //   case 0: 
            //     window.shoTooHot && window.shoTooHot(true);// 控制toast 
            //   break 
            // }
            // 未登录
            if (error) {
                reject(error);
            }
        });
    })

    return _p;
}

export {
    MethodType,
    promiseRequest,
}


// WEBPACK FOOTER //
// ./src/utils/promise.js